import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {




  
  markersDaDashboard=[

    {
      address:"Via roma,593 Marigliano NA",
      
      isDraggable:true,
      tooltip:{
        text:"<strong>Sede</strong>",
        isShown:true
      }
    },
    {
      address:"Via roma nola na",
      isDraggable:true,
      tooltip:{
        text:"Casa di nola",
        isShown:true
      }
    },
    {
      address:"Via aliperti,25 saviano na",
      isDraggable:true,
      tooltip:{
        text:"A casa mia",
        isShown:true
      },
      


    },
    {
      address:"Via Torre saviano na",
      isDraggable:true,
      tooltip:{
        text:"A casa mia",
        isShown:true
      },
      


    }

  ];


  jsonPerGrafico2:string=JSON.stringify({
    titolo:'Grafico Plastica Trasportata',
    tipoGrafico:'torta',
    opzioniStile:{
      altezza:"100px"

    },
    dati:[
      {
      gruppo:'PET',

          series:[
            {name:'anno 2015',value:25},
            {name:'anno 2016',value:30},
            {name:'anno 2017',value:112}
          ],

      tooltip:'Polietilene tereftalato'  
      },
      {
      gruppo:'HDPE',

      series:[
        {name:'anno 2015',value:80},
        {name:'anno 2016',value:82},
        {name:'anno 2017',value:50}
      ],

    tooltip:'Polietilene ad alta densità'  

      },
      {
      gruppo:'PVC',

      series:[
        {name:'anno 2015',value:30},
        {name:'anno 2016',value:20},
        {name:'anno 2017',value:50}
      ],

    tooltip:'Polivinilcloruro'  

    }
  ]
  });

  jsonPerGrafico:string=JSON.stringify({
    titolo:'Grafico Plastica Trasportata',
    tipoGrafico:'barre',
    opzioniStile:{
      altezza:"100px"

    },
    dati:[
      {
      gruppo:'PET',

          series:[
            {name:'anno 2015',value:25},
            {name:'anno 2016',value:30},
            {name:'anno 2017',value:112}
          ],

      tooltip:'Polietilene tereftalato'  
      },
      {
      gruppo:'HDPE',

      series:[
        {name:'anno 2015',value:80},
        {name:'anno 2016',value:82},
        {name:'anno 2017',value:50}
      ],

    tooltip:'Polietilene ad alta densità'  

      },
      {
      gruppo:'PVC',

      series:[
        {name:'anno 2015',value:30},
        {name:'anno 2016',value:20},
        {name:'anno 2017',value:50}
      ],

    tooltip:'Polivinilcloruro'  

    }
  ]
  });
  constructor() { }

  ngOnInit() {
  }

}
